import React from "react";
import { Grid, Button } from "@mui/material/";
import BackspaceIcon from "@mui/icons-material/Backspace";

function CalculatorItem({ value, updateAmount }) {
  return (
    <Grid
      item
      xs={3}
      sx={{
        display: "flex",
        alignContent: "center",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Grid
        item
        sx={{
          height: "100px",
          width: "100px",
          display: "flex",
          alignContent: "center",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {value !== null && (
          <Button
            variant="contained"
            component="label"
            disableElevation
            sx={{
              height: "100%",
              width: "100%",
              fontSize: "35px",
              fontWeight: 700,
              // gradients match the btn-custom-* tones in assets/css/buttons.css
              background:
                value === "backspace"
                  ? "linear-gradient(160deg, #ff9ecf 0%, #e05fa3 100%)"
                  : "linear-gradient(160deg, #9dafbd 0%, #6d8190 100%)",
              boxShadow:
                value === "backspace"
                  ? "0 4px 12px rgba(252,134,193,0.2), inset 0 1px 0 rgba(255,255,255,0.14)"
                  : "0 4px 12px rgba(136,156,171,0.2), inset 0 1px 0 rgba(255,255,255,0.14)",
              color: "white",
              borderRadius: "12px",
              marginTop: "20px",
              transition: "transform 80ms ease, box-shadow 80ms ease",
              // :hover is stripped app-wide, so press feedback lives on :active
              "&:active": {
                transform: "translateY(3px)",
                boxShadow: "0 2px 6px rgba(0,0,0,0.18), inset 0 1px 0 rgba(255,255,255,0.1)",
              },
            }}
            onClick={() => {
              updateAmount(value);
            }}
          >
            {value == "backspace" ? <BackspaceIcon /> : value}
          </Button>
        )}
      </Grid>
    </Grid>
  );
}

export default CalculatorItem;
